const Enum = {};
Enum.set = (...args) => {
  const o = {};

  // Initialize the enum counter as necessary
  if (typeof Enum.enumCtr === 'undefined') {
    Enum.enumCtr = 0;
  }
  // Assign a unique value to each item, using the enum counter
  for (let i = 0; i < args.length; i += 1) {
    const num = Enum.enumCtr++;
    o[args[i]] = num;
    o[num] = args[i];
  }

  return o;
};

export default Enum;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/util/EnumUtil.js